const crypto = window.crypto || window.msCrypto

const generatePassword = (length = 10) => {
  const buffer = new Uint8Array(12)
  crypto.getRandomValues(buffer)
  return btoa(String.fromCharCode.apply(null, buffer)).substr(0, length)
}

export default generatePassword
